import React from 'react';
import { HYPER_DUSK_IMAGE_CREDITS, HYPER_DUSK_VIDEO_CREDITS } from '../types';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();
  const logoSrc = '/hyperdusk-logo-wordmark-alpha.png';

  return (
    <footer className="relative z-10 border-t border-white/10 bg-black/35 backdrop-blur-sm">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="md:col-span-1">
            <div className="mb-3">
              <img src={logoSrc} alt="Hyper Dusk" className="h-6 w-auto object-contain object-left mix-blend-screen brightness-110 contrast-110" />
            </div>
            <p className="text-xs text-slate-500 leading-relaxed">
              Day-to-night AI for real estate marketing. Generate dusk images, approve versions, and animate cinematic transitions.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-orange-300 uppercase tracking-wider mb-3">Product</h4>
            <ul className="space-y-2 text-xs text-slate-500">
              <li>Day-to-Night Conversion</li>
              <li>Approval-First Workflow</li>
              <li>Multiple Dusk Variants</li>
              <li>Cinematic Animation Output</li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-orange-300 uppercase tracking-wider mb-3">Pricing</h4>
            <ul className="space-y-2 text-xs text-slate-500">
              <li className="flex items-center gap-1.5">
                <span className="w-1.5 h-1.5 bg-green-400 rounded-full" />
                Shared credits with ReHub account
              </li>
              <li>Evening images from {HYPER_DUSK_IMAGE_CREDITS} credits</li>
              <li>Full Hyper Dusk video {HYPER_DUSK_VIDEO_CREDITS} credits</li>
              <li>Subscription and one-time packs</li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-orange-300 uppercase tracking-wider mb-3">Company</h4>
            <ul className="space-y-2 text-xs text-slate-500">
              <li>
                <a href="https://hub.rehub.studio" target="_blank" rel="noopener noreferrer" className="hover:text-orange-300 transition-colors">
                  ReHub Studio
                </a>
              </li>
              <li>
                <a href="https://hub.rehub.studio/#/contact" className="hover:text-orange-300 transition-colors">
                  Contact
                </a>
              </li>
              <li>
                <a href="https://rehub.studio/terms" target="_blank" rel="noopener noreferrer" className="hover:text-orange-300 transition-colors">
                  Terms
                </a>
              </li>
              <li>
                <a href="https://rehub.studio/privacy" target="_blank" rel="noopener noreferrer" className="hover:text-orange-300 transition-colors">
                  Privacy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-6 border-t border-slate-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[11px] text-slate-600">
            © {year} ReHub Studio. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-[11px] text-slate-600">
            <span>Part of the ReHub Suite</span>
            <span className="text-slate-700">·</span>
            <span>One account, all apps</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
